// extracted by mini-css-extract-plugin
export var gridMods = "CaseStudyList-module--grid-mods--d3556";
export var nextPage = "CaseStudyList-module--next-page--ab8b3";
export var nextPageButtonGroup = "CaseStudyList-module--next-page-button-group--3b112";